import {ColumnDeclaration} from './wjgrid-utils';
import {Row} from '@mescius/wijmo.grid';
import {DataType} from '@mescius/wijmo';

export class CompactSummaryTables {

    static TargetInfoColumnsGnwpNlr : ColumnDeclaration[] = [
        CompactSummaryTables.rdCol('GNWP, m EUR', 'gnwpEur', 'n1,,'),
        CompactSummaryTables.rdCol('NLR (%)', 'nlr', 'p1'),
    ];

    static TargetInfoColumnsRateChangeRetentionRate : ColumnDeclaration[] = [
        CompactSummaryTables.rdCol('Rate Change', 'rateChange', 'p1'),
        CompactSummaryTables.rdCol('Retention Rate', 'retentionRate', 'p1'),
    ];

    static TargetInfoColumns : ColumnDeclaration[] = [
        ...CompactSummaryTables.TargetInfoColumnsGnwpNlr, ...CompactSummaryTables.TargetInfoColumnsRateChangeRetentionRate
    ];

    static generateTargetInfoColumns(bindingSuffix: string): ColumnDeclaration[] {
        return CompactSummaryTables.TargetInfoColumns.map((col) => ({
            ...col,
            binding: `${col.binding}${bindingSuffix}`
        }));
    }

    static generateTargetInfoColumnsGnwpNlr(bindingSuffix: string): ColumnDeclaration[] {
        return CompactSummaryTables.TargetInfoColumnsGnwpNlr.map((col) => ({
            ...col,
            binding: `${col.binding}${bindingSuffix}`,
        }));
    }

    static rdCol(header: string, binding: string, format: string): ColumnDeclaration {
        return { header, binding, format, isRequired: false, align: 'center', width: 60, dataType: DataType.Number };
    }
}
